var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7297 4.57745V14.2172H22.5555V15.7695H14.1708V4.58476C8.793 5.00824 4.55224 9.51457 4.55224 15C4.55224 20.7645 9.23549 25.4478 15 25.4478C20.7645 25.4478 25.4478 20.7645 25.4478 15C25.4478 9.48102 21.1489 4.95315 15.7297 4.57745ZM3 15C3 8.37314 8.37313 3 15 3C21.6269 3 27 8.37314 27 15C27 21.6269 21.6269 27 15 27C8.37313 27 3 21.6269 3 15Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlueClock.d07292ab8de48ded24f2e0c114c5095d.svg";